module.exports = __webpack_public_path__ + "static/media/streamline_process.110ff86b.webp";